// extracted by mini-css-extract-plugin
export default {"header":"section-wrapper_header__KTc9m","icon":"section-wrapper_icon__w1buz"};